import React from 'react';
import {
  XMarkIcon,
  ArrowDownTrayIcon,
  BellIcon,
  BoltIcon,
  WifiIcon,
} from '@heroicons/react/24/outline';
import { usePWA } from '../../hooks/usePWA';
import { useTranslation } from 'react-i18next';

export const InstallBanner: React.FC = () => {
  const { t } = useTranslation();
  const { canShowInstall, isIOS, installPrompt, dismissInstall } = usePWA();

  if (!canShowInstall) {
    return null;
  }

  return (
    <div className="fixed top-0 left-0 right-0 z-50 bg-gradient-to-r from-purple-600 to-purple-700 text-white shadow-lg animate-slide-down">
      <div className="max-w-mobile md:max-w-desktop mx-auto px-4 py-3">
        <div className="flex items-start justify-between">
          <div className="flex items-start space-x-3 flex-1">
            <div className="flex-shrink-0 mt-1">
              <ArrowDownTrayIcon className="w-5 h-5" />
            </div>
            <div className="flex-1 space-y-2">
              <div className="font-semibold text-sm">
                {t('pwa.install.title', 'Install ChatNexus App')}
              </div>
              <div className="text-xs opacity-90 space-y-1">
                <div className="flex items-center space-x-2">
                  <BellIcon className="w-3 h-3" />
                  <span>{t('pwa.install.benefit1', 'Get instant companion messages')}</span>
                </div>
                <div className="flex items-center space-x-2">
                  <BoltIcon className="w-3 h-3" />
                  <span>{t('pwa.install.benefit2', 'Lightning fast performance')}</span>
                </div>
                <div className="flex items-center space-x-2">
                  <WifiIcon className="w-3 h-3" />
                  <span>{t('pwa.install.benefit3', 'Works offline')}</span>
                </div>
              </div>
              <div className="flex items-center space-x-2 pt-1">
                <button
                  onClick={installPrompt}
                  className="bg-white text-purple-700 px-3 py-1.5 rounded-md text-xs font-semibold hover:bg-gray-100 transition-colors"
                >
                  {isIOS
                    ? t('pwa.install.showHow', 'Show Me How')
                    : t('pwa.install.button', 'Install Now')}
                </button>
                <button
                  onClick={dismissInstall}
                  className="text-white/80 hover:text-white text-xs underline"
                >
                  {t('pwa.install.later', 'Maybe Later')}
                </button>
              </div>
            </div>
          </div>
          <button
            onClick={dismissInstall}
            className="flex-shrink-0 p-1 hover:bg-white/10 rounded transition-colors"
            aria-label="Close"
          >
            <XMarkIcon className="w-4 h-4" />
          </button>
        </div>
      </div>
    </div>
  );
};
